import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import GNB from './components/GNB';
import AppInstallStrip from './components/AppInstallStrip';
import Footer from './components/Footer';
import ListPage from './pages/ListPage';
import DetailPage from './pages/DetailPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProfilePage from './pages/ProfilePage';
import ScrapPage from './pages/ScrapPage';
import TermsOfService from './terms/TermsOfService';
import PrivacyPolicy from './terms/PrivacyPolicy';
import SupportPage from './pages/SupportPage';
import DownloadPage from './pages/DownloadPage';
import AppRedirectPage from './pages/AppRedirectPage';
import DesignSystemPage from './pages/DesignSystemPage';
import { AuthProvider } from './context/AuthContext';
import { ScrapProvider } from './context/ScrapContext';
import './styles/global.css';
import NotFoundPage from './pages/NotFoundPage';

// 약관·개인정보·고객지원은 푸터에서 들어오는 일반 콘텐츠 페이지라 GNB·푸터를 함께 보여준다.
const AUTH_PATHS = ['/login', '/signup', '/reset-password'];
const NO_GNB_PATHS = [...AUTH_PATHS, '/mypage', '/download', '/design-system', '/app'];
const NO_FOOTER_PATHS = [...AUTH_PATHS, '/download', '/design-system', '/app'];

function Layout() {
  const { pathname } = useLocation();
  const hideGNB = NO_GNB_PATHS.includes(pathname) || pathname.startsWith('/profile/');
  const hideFooter = NO_FOOTER_PATHS.includes(pathname) || pathname.startsWith('/profile/');

  return (
    <>
      {!hideGNB && <AppInstallStrip />}
      {!hideGNB && <GNB />}
      <Routes>
        <Route path="/" element={<ListPage />} />
        <Route path="/campaign/:id" element={<DetailPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/mypage" element={<Navigate to="/" replace />} />
        <Route path="/scrap" element={<ScrapPage />} />
        <Route path="/profile/:username" element={<ProfilePage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/app" element={<AppRedirectPage />} />
        <Route path="/design-system" element={<DesignSystemPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrapProvider>
          <Layout />
        </ScrapProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
